/**
 * Calculates the angle in degrees between two points (cx, cy) and (ex, ey).
 * The angle is measured from the horizontal axis to the line connecting the two points,
 * with the result in the range (-180, 180].
 *
 * @param {number} cx - X coordinate of the center point.
 * @param {number} cy - Y coordinate of the center point.
 * @param {number} ex - X coordinate of the end point.
 * @param {number} ey - Y coordinate of the end point.
 * @returns {number} Angle in degrees between the two points.
 */
const calculateAngle = (cx, cy, ex, ey) => {
  const dy = ey - cy;
  const dx = ex - cx;
  let theta = Math.atan2(dy, dx); // range (-PI, PI]
  theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
  return theta;
};

export default calculateAngle;
